Drupal.behaviors.sidebarMenuToggle = {
  attach(context) {
    // Select all sidebar menus within the sidebar region
    const sidebars = context.querySelectorAll('.sidebar_region .sidebar nav');

    const slideDown = (element) => {
      element.style.display = 'block';
      const height = `${element.scrollHeight}px`;
      element.style.height = height;

      element.addEventListener('transitionend', function handler() {
        element.style.height = 'auto';
        element.removeEventListener('transitionend', handler);
      });

      requestAnimationFrame(() => {
        element.style.transition = 'height 0.3s ease';
        element.style.height = height;
      });
    };

    const slideUp = (element) => {
      const height = `${element.scrollHeight}px`;
      element.style.height = height;

      requestAnimationFrame(() => {
        element.style.transition = 'height 0.3s ease';
        element.style.height = '0';
      });

      element.addEventListener('transitionend', function handler() {
        element.style.display = 'none';
        element.removeEventListener('transitionend', handler);
      });
    };

    sidebars.forEach((sidebar) => {
      const menuHeading = sidebar.querySelector('h2[id^="block-msu-drupal-"]');
      const menu = sidebar.querySelector('.menu');

      if (menuHeading && menu) {
        menuHeading.addEventListener('click', () => {
          if (menu.classList.contains('menu--visible')) {
            slideUp(menu);
          } else {
            slideDown(menu);
          }
          menu.classList.toggle('menu--visible');
          menuHeading.classList.toggle('expanded');
          menuHeading.classList.toggle('rotated');
        });
      }
    });
  },
};
